import {Component, computed, ChangeDetectionStrategy} from "@angular/core"
import {narrowInstance} from "@cm/utils"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {MatMenuModule} from "@angular/material/menu"
import {SelectionPossibilities, ValueSlotComponent} from "@template-editor/components/value-slot/value-slot.component"
import {ProceduralMesh, StoredMesh, CutMesh, ProfileExtrudeMesh, MeshNode, GeometryGraphMesh, commonGeometryGraphTable} from "@cm/template-nodes"
import {ButtonComponent} from "@common/components/buttons/button/button.component"
import * as changeCase from "change-case"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-mesh-inspector",
    templateUrl: "./mesh-inspector.component.html",
    styleUrl: "./mesh-inspector.component.scss",
    imports: [InspectorSectionComponent, MatMenuModule, ValueSlotComponent, ButtonComponent],
})
export class MeshInspectorComponent extends BaseInspectorComponent<MeshNode> {
    readonly $proceduralMesh = computed(() => narrowInstance(this.$node(), ProceduralMesh))
    readonly $cutMesh = computed(() => narrowInstance(this.$node(), CutMesh))
    readonly $profileExtrudeMesh = computed(() => narrowInstance(this.$node(), ProfileExtrudeMesh))
    readonly $geometryGraphMesh = computed(() => narrowInstance(this.$node(), GeometryGraphMesh))

    readonly $allowsSubdivision = computed(() => {
        return true
    })

    readonly $allowsAddRemoveMaterialSlots = computed(() => {
        const node = this.$node()
        return !(node instanceof StoredMesh)
    })

    geometryPossibilities: SelectionPossibilities<string> = Object.keys(commonGeometryGraphTable).map((key) => ({
        value: key,
        name: changeCase.capitalCase(key),
    }))

    addMaterialSlot() {
        this.sceneManagerService.modifyTemplateGraph(() => {
            const {materialAssignments} = this.$parameters()
            for (let slotIdx = 0; slotIdx < 100; slotIdx++) {
                const slot = slotIdx.toString()
                if (!(slot in materialAssignments.parameters)) {
                    materialAssignments.updateParameters({[slot]: null})
                    break
                }
            }
        })
    }

    removeEmptyMaterialSlots() {
        this.sceneManagerService.modifyTemplateGraph(() => {
            const {materialAssignments} = this.$parameters()
            const filtered = Object.fromEntries(Object.entries(materialAssignments.parameters).filter(([, value]) => value !== null))
            materialAssignments.replaceParameters(filtered)
        })
    }
}
